import DownloadPage from "../components/pages/DownloadPage/download-page.component";

export default DownloadPage;
